import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { AppConfig } from '../config';

export function useLookups(config: AppConfig) {
  return useQuery({
    queryKey: ['lookups'],
    queryFn: () => api.lookups(config),
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
}
